var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn_area type_fr"},[_c('button',{staticClass:"btn_default",style:({minWidth: '150px'}),attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.onClickButton}},[_vm._v(_vm._s(_vm.buttonText))])])}
var staticRenderFns = []

export { render, staticRenderFns }